import PropTypes from 'prop-types'

const TotalSentIcon = ({ title }: any) => (
  <svg width={34} height={30} viewBox="0 0 34 30">
    <title>{title}</title>
    <path
      d="M32.31 13.791c-.114-1.42-9.724-11.485-11.036-11.617-.875-.087-1.208 2.56-1.001 7.945-4.73 0-10.366 1.07-14.247 4.788-2.782 2.666-3.77 6.694-3.77 12.667.03.878 7.108-8.728 18.017-8.728.321 5.265 1.099 7.484 2.333 6.658 1.852-1.24 9.818-10.292 9.704-11.713z"
      strokeWidth={3}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)

TotalSentIcon.displayName = 'TotalSentIcon'

TotalSentIcon.propTypes = {
  title: PropTypes.string
}

TotalSentIcon.defaultProps = {
  title: 'TotalSent'
}

export default TotalSentIcon
